var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHamburgerMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2185",
    "data-name": "Group 2185",
    transform: "translate(-300 -22.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    x1: 32,
    transform: "translate(300 24)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6255",
    "data-name": "Path 6255",
    d: "M32,0H0",
    transform: "translate(300 37)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    "data-name": "Line 19",
    x1: 32,
    transform: "translate(300 50)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerMenu);
export default __webpack_public_path__ + "static/media/hamburger_menu.e2feba5a3e72c4ce0faeccc5c195c817.svg";
export { ForwardRef as ReactComponent };